<template>
  <div class="wrapper add-knowledge">
    <b-modal
      id="modal"
      v-model="isOpen"
      header-bg-variant="light"
      footer-bg-variant="light"
      :title="$t('pages.user-cv.document.modal.title', 'Edit document')"
      :ok-title="$t('generic.save', 'Save')"
      :cancel-title="$t('generic.cancel', 'Cancel')"
      @hidden="$emit('closeModal'); file = null;"
      @ok.prevent="submit"
    >
      <div
        v-if="document.document"
        class="mb-3"
      >
        <div>{{ $t('pages.user-cv.document.current-cv-document', 'Your current CV document') }}</div>
        <div
          class="document-download"
          @click="showCV"
        >
          <font-awesome-icon
            icon="download"
          />
          {{ document.document }}
        </div>
        <div>
          <font-awesome-icon
            icon="clock"
          />
          {{ $t('pages.user-cv.document.last-updated', 'Last update on:') }} {{ document.created_at }}
        </div>
      </div>
      <label for="speakSelect">{{ $t('pages.user-cv.document.modal.update-document', 'Update document') }}</label>
      <b-form-file
        id="file-input"
        v-model="$v.file.$model"
        :placeholder="$t('pages.user-cv.document.modal.select-file', 'Select a file')"
        :drop-placeholder="$t('pages.user-cv.document.modal.drop-file', 'Drop file here...')"
        :state="$v.file.$dirty ? !$v.file.$error : null"
        :browse-text="$t('generic.browse', 'Browse')"
      />
      <div
        v-if="uploadPercentage > 0"
        class="mt-1"
      >
        <progress
          max="100"
          :value.prop="uploadPercentage"
          style="width: 100%"
        />
      </div>
      <span style="font-size: 0.7rem; color: #666">{{ $t('pages.user-cv.document.modal.requirements', '*Max. 2MB, .doc, .docx or .pdf') }}</span>
      <b-form-invalid-feedback :state="$v.file.$model === null ? !$v.file.$error : null">
        {{ $t('pages.user-cv.document.modal.please-select-file', 'Please select a document') }}
      </b-form-invalid-feedback>
      <b-form-invalid-feedback :state="$v.file.$dirty && $v.file.$model != null ? !$v.file.$error : null">
        {{ $t('pages.user-cv.document.modal.invalid-file', 'Selected document does not meet the requirements') }}
      </b-form-invalid-feedback>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

const lessThanTwoMb = (value) => { if(!value) return false; else return value.size <= 2 * 1000 * 1000 };
const goodFileFormat = (value) => {
  if(!value)
    return false;
  else {
    return value.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
           value.type === "application/msword" ||
           value.type === "application/pdf";
  }
};

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    document: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      file: null,
      uploadPercentage: 0
    }
  },
  validations: {
    file: { required, lessThanTwoMb, goodFileFormat  }
  },
  methods: {
    submit() {
      this.cvUpload(this.file);
    },
    cvUpload(file) {
      const fd = new FormData();
      fd.append('category', 'cv_v2');
      fd.append('file', file);

      // Upload a file
        this.axios
          .post('/files/upload', fd, {
            headers: {
              'Content-type': 'multipart/form-data'
            },
            onUploadProgress: function( progressEvent ) {
              this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
            }.bind(this)
          })
        .then( (response) => {
          this.save(response.data);
          this.$emit('closeModal');
          this.uploadPercentage = 0;
        })
        .catch( (error) => {
          this.$toastNotification('danger', '', error.response.data.error);
        })
    },
    save(data) {
      let form = {
        file: data.filename,
        created_at: data.created_at
      };

      this.axios
        .put('/cv/update/document', form)
        .then( response => {
            this.$emit('updateCv', response.data);
            this.$emit('closeModal');
            this.file = null;
          })
        .catch();
    },
    showCV() {
      window.open(process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH + 'uploads/cv_v2/' + this.document.document);
    },
  }
}
</script>

<style lang="scss">
  .document-download {
    font-size: 1.2rem;
    cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
  }
</style>
